import { Box, FormControl, Stack, TextField, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { ObservabilityToolHeaders } from 'components/status-checks/form/authentication/ObservabilityToolHeaders'
import { ObservabilityToolPrivateNetworkIntegration } from 'components/status-checks/form/authentication/ObservabilityToolPrivateNetworkIntegration'
import { StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { ObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { useTranslation } from 'hooks/use-translation'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

export const ObservabilityToolOtherAuthenticationDetails: React.FC = () => {
  const { trans } = useTranslation()
  const { control, formState } = useFormContext<StatusCheckFormValues>()
  const { isEdit } = useContext(ObservabilityToolAuthenticationContext)

  const observabilityToolType = useWatch<StatusCheckFormValues>({
    control,
    name: 'observabilityTool.type'
  })

  const hasPrivateNetworkIntegrationOption =
    observabilityToolType === ObservabilityToolType.GRAFANA ||
    observabilityToolType === ObservabilityToolType.DYNATRACE

  return (
    <Stack spacing={3}>
      <FormControl>
        {/* Using the Controller wrapper here because this value will be dynamically updated as other form values are selected */}
        <Controller
          control={control}
          name="apiBaseUrl"
          render={({ field }) => (
            <TextField
              {...field}
              data-testid="observability-tool-authentication-api-base-url-input"
              disabled={isEdit}
              error={Boolean(formState.errors.apiBaseUrl)}
              helperText={formState.errors.apiBaseUrl?.message}
              label={trans(
                'forms.save_status_checks.authentication.api_base_url.text_field.label'
              )}
              variant="outlined"
            />
          )}
        />
      </FormControl>
      {hasPrivateNetworkIntegrationOption && (
        <ObservabilityToolPrivateNetworkIntegration />
      )}
      <Box>
        <Typography mb={2} variant="h6">
          {trans('forms.save_status_checks.authentication.header.label')}
        </Typography>
        <Stack ml={2} spacing={2}>
          <Typography>
            {trans('forms.save_status_checks.authentication.headers.prompt')}
          </Typography>
          <ObservabilityToolHeaders isCustomObservabilityTool={false} />
        </Stack>
      </Box>
    </Stack>
  )
}
